import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  modalImage();
});


/* ----------------------------------
  　お問い合わせ関連
---------------------------------- */
// // //お問い合わせバリデーション
if(document.body.classList.contains("home")){
  topValidation('zip', 'address01', 'address02');
}


gsap.registerPlugin(ScrollToPlugin);

// お問い合わせスクロール
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;
  const extraOffset = 100;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });
});



/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  const navEle = document.querySelector('.hd_menu-toggle');
  const navWrap = document.querySelector('.hd_nav');
  const navItems = document.querySelectorAll('.hd_nav_li');

  // メニューを閉じる関数
  const closeMenu = () => {
    navItems.forEach((item, i) => {
      setTimeout(() => {
        item.classList.remove('show');
      }, i * 80);
    });

    // パネル自体も同時に左へスライド
    navWrap.classList.add('hide-panel');
    setTimeout(() => {
      navWrap.classList.remove('is_open', 'hide-panel');
    }, 500); // CSSトランジション時間に合わせる

    navEle.classList.remove('is_open');
  };

  // ハンバーガーメニュークリック
  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    if (!isOpen) {
      // 開くとき
      navWrap.classList.add('is_open');

      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.add('show');
          item.classList.remove('hide');
        }, i * 120);
      });

      navEle.classList.add('is_open');
    } else {
      // 閉じるとき
      closeMenu();
    }
  });

  // グローバルナビ内のリンクとボタンをクリックした時にメニューを閉じる（970px以下の時のみ）
  const navLinks = navWrap.querySelectorAll('a, button');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      // 画面幅970px以下の場合のみメニューを閉じる
      if (window.innerWidth <= 970 && navWrap.classList.contains('is_open')) {
        closeMenu();
      }
    });
  });
});




/* ----------------------------------
　施工実績
---------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  // 施工実績セクションの存在確認
  const achievementsSection = document.querySelector('.service_achievements');
  if (!achievementsSection) return;

  // デスクトップ用タブの初期化
  initDesktopTabs();

  // モバイル用アコーディオンの初期化
  initMobileAccordion();

  // テーブルスクロールヒントの初期化
  initScrollHint();
});

/**
 * デスクトップ用タブ機能
 */
function initDesktopTabs() {
  const tabButtons = document.querySelectorAll('.year-tab');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const year = this.getAttribute('data-year');
      switchYear(year);
      
      // タブのアクティブ状態を更新
      tabButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
}

/**
 * モバイル用アコーディオン機能
 */
function initMobileAccordion() {
  const accordionTrigger = document.querySelector('.year-accordion-trigger');
  const accordionContent = document.querySelector('.year-accordion-content');
  const yearOptions = document.querySelectorAll('.year-option');
  
  if (!accordionTrigger || !accordionContent) return;

  // アコーディオンの開閉
  accordionTrigger.addEventListener('click', function() {
    const isOpen = this.classList.contains('open');
    
    if (isOpen) {
      this.classList.remove('open');
      accordionContent.classList.remove('open');
    } else {
      this.classList.add('open');
      accordionContent.classList.add('open');
    }
  });

  // 年度オプションのクリック
  yearOptions.forEach(option => {
    option.addEventListener('click', function() {
      const year = this.getAttribute('data-year');
      switchYear(year);
      
      // オプションのアクティブ状態を更新
      yearOptions.forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
      
      // 選択された年度をトリガーに表示
      const currentYearSpan = accordionTrigger.querySelector('.current-year');
      if (currentYearSpan) {
        currentYearSpan.textContent = year + '年度';
      }
      
      // アコーディオンを閉じる
      accordionTrigger.classList.remove('open');
      accordionContent.classList.remove('open');
    });
  });

  // アコーディオン外をクリックしたら閉じる
  document.addEventListener('click', function(e) {
    const accordion = document.querySelector('.year-accordion');
    if (accordion && !accordion.contains(e.target)) {
      accordionTrigger.classList.remove('open');
      accordionContent.classList.remove('open');
    }
  });
}

/**
 * 年度を切り替える共通関数
 * @param {string} year - 切り替える年度
 */
function switchYear(year) {
  const allContents = document.querySelectorAll('.achievement-year-content');
  const targetContent = document.querySelector(`.achievement-year-content[data-year="${year}"]`);
  
  // すべてのコンテンツを非表示
  allContents.forEach(content => content.classList.remove('active'));
  
  // 選択された年度のコンテンツを表示
  if (targetContent) {
    targetContent.classList.add('active');
    
    // 年度切り替え時にスクロールヒントをリセット
    resetScrollHint();
  }
}

/**
 * テーブルスクロールヒントの初期化
 */
function initScrollHint() {
  const tableWrappers = document.querySelectorAll('.table-wrapper');
  
  tableWrappers.forEach(wrapper => {
    // スクロールイベントを監視
    wrapper.addEventListener('scroll', function() {
      if (this.scrollLeft > 0) {
        this.classList.add('scrolled');
      }
    }, { passive: true });

    // 初期状態で少しでもスクロール可能ならヒントを表示
    if (wrapper.scrollWidth > wrapper.clientWidth) {
      wrapper.classList.remove('scrolled');
    } else {
      // スクロール不要な場合はヒントを非表示
      wrapper.classList.add('scrolled');
    }
  });
}

/**
 * スクロールヒントをリセット
 */
function resetScrollHint() {
  const activeContent = document.querySelector('.achievement-year-content.active');
  if (!activeContent) return;

  const wrapper = activeContent.querySelector('.table-wrapper');
  if (!wrapper) return;

  // スクロール位置をリセット
  wrapper.scrollLeft = 0;

  // スクロール可能な場合のみヒントを再表示
  if (wrapper.scrollWidth > wrapper.clientWidth) {
    wrapper.classList.remove('scrolled');
  } else {
    wrapper.classList.add('scrolled');
  }
}



/* ----------------------------------
　MVタイトル表示
---------------------------------- */
window.addEventListener('load', () => {
  const loading = document.querySelector('.loading');
  const ttl = document.querySelector('.top_mv_ttl_wrap');
  if (!ttl) return;

  if (loading) {
    loading.addEventListener('transitionend', () => {
      ttl.classList.add('is_show');
    }, { once: true });
  } else {
    ttl.classList.add('is_show');
  }
});

/* ----------------------------------
  スクロールフェードイン
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const fadeElements = document.querySelectorAll('.fade_up,.fade_left');
  if (!fadeElements.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is_show');
          obs.unobserve(entry.target); // 一度だけ
        }
      });
    },
    {
      root: null,        // viewport
      rootMargin: '0px 0px -15% 0px',
      threshold: 0
    }
  );

  fadeElements.forEach(el => observer.observe(el));
});

/* ----------------------------------
　HOME　商品紹介　下から上にフェードイン
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".cmn_list_item");

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const index = Array.from(blocks).indexOf(entry.target);
      entry.target.style.transitionDelay = `${index * 0.15}s`;
      entry.target.classList.add("is_up");
      observer.unobserve(entry.target);
    }
  });
}, {
  root: null,
  rootMargin: '0px 0px -5% 0px', // ← ここ
  threshold: 0
});

  blocks.forEach((block) => observer.observe(block));
});